import request from '../../../api';

/**
 * Admin-managed page content, keyed by setting name.
 *
 * The backend stores the value as a JSON *string* holding one blob of HTML per
 * language, so the response needs a second parse before it is usable:
 *
 *     { data: { data: '{"ar":"<p>…</p>","en":"<p>…</p>"}' } }
 *
 * Callers get `{ ar, en }` and pick their language.
 */
export const getSetting = (settingKey) =>
    request.get(`/public/setting/${settingKey}/value`).then(res => {
        const raw = res.data?.data;
        if (!raw) return { ar: '', en: '' };

        // A malformed value must not take the page down with a parse error —
        // an empty document renders the "nothing here yet" state instead.
        try {
            const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
            return { ar: parsed.ar ?? '', en: parsed.en ?? '' };
        } catch {
            return { ar: '', en: '' };
        }
    });
